import { te } from 'date-fns/locale'

export const ROUTES = {
  home: '/home',
  waitListLanding: '/',
  sAppHome: '/super-app-home',
  create: '/create',
  discover: '/discover',
  dashboard: '/dashboard',
  dashboardFilter: '/dashboard/filter',
  aiDashboard: '/ai/dashboard',
  deleteAccount: '/deleteAccount',
  login: '/login',
  profile: '/profile',
  studio: '/studio',
  imageEnhance: '/imageEnhance',
  subscription: '/subscription',
  payment: '/payment',
  updatedPayment: '/updatedPayment',
  theme_options: '/setting/theme',
  langauge_options: '/setting/language',
  wallet: '/wallet',
  rewards: '/rewards',
  earnCoin: '/earnCoin',
  transactions: '/transactions',
  rewardSelect: '/rewardSelect',
  paymentActivation: '/paymentActivation',
  paymentFailed: '/paymentFailed',
  subscriptionSettingPlan: '/subscriptionPlan',
  subscriptionHistory: '/subscriptionHistory',
  updatePromo: '/updatePromo',
  notification: '/setting/notifications',
  notifications: '/notifications',
  updateEmail: '/update-email',
  forgotPwd: '/forgotPwd',
  newPassword: '/newPassword',
  register: '/register',
  setting: '/setting',
  consent: '/setting/consent',
  cardDetail: '/cardDetail',
  DeleteAccount: '/DeleteAccount',
  deleteaccount: '/delete-account',
  search: '/search',
  filterTransaction: '/filterTransaction',
  cancleSubscription: '/cancleSubscription',
  waitListWelcome: '/waitList-welcome',
  waitListLogIn: '/waitList-login',
  waitListOTP: '/waitList-otp',
  waitListSuccess: '/waitList-success',
  waitListInvite: '/waitList-invite',
  splash: '/splash',
  sSearch: '/super-search',
  feedback: '/feedback',
  selectBackground: '/selectBackground',
  erosAi: '/eros-ai',
  eternal: '/eternal/*',
  // erosAi: '/eros-ai',
  voiceCloneLanding: '/ai-tool/voiceClone',
  voiceLibrary: '/ai-tool/voiceLibrary',
  voiceRecorder: '/ai-tool/voiceRecorder',
  editVoiceClone: '/ai-tool/editVoiceClone',
  textToImage: '/ai-tool/text-to-image',
  textToVideo: '/ai-tool/text-to-video',
  voiceRemix: '/ai-tool/voice-remix',
  talkingAvatarLanding: '/ai-tool/talkingAvatar',
  actionGeneration: '/ai-tool/actionGeneration',
  imageToVideo: '/ai-tool/image-to-video',
  faceSwap: '/ai-tool/face-swap',
  colorize: '/ai-tool/colorize',
  sceneSwap: '/ai-tool/scene-swap',
  motionControl: '/ai-tool/motioncontrol',
  songGeneration: process.env.REACT_APP_SONG_GENERATION_URL,
  videoDubbing: process.env.REACT_APP_VIDEO_DUBBING_URL,
  content: '/content',
  createReels: '/create-reels',
  imageList: '/imageList',
  audioPreviewList: '/audioPreviewList',
  audioPreview: '/audioPreview',
  country: '/country',
  creatorList: '/creatorList',
  updateEmail: '/setting/update-email',
  updatePassword: '/setting/update-password',
  faq: '/faq',
  source: '/source',
  blockedUserList: '/setting/blockUserList',
  privacy: '/privacy',
  terms: '/terms',

  superAppImageList: "/imageList/superApp",
  creatorAppImageList: "/imageList/creatorApp",
  dashboardImageList: "/imageList/dashboard",
  creativeEditor: '/creative-editor',
  moderation: "/moderation",
  otpVarification: "/otpVerification",
  verifySignup:"/verifySignup",
  pswUpdated:"/pswUpdated",
  selectTemplate:"/selectTemplate",
  outPut:"/output",
  avatar: "/avtar",
  editProfile: "/editProfile",
  popularMovies:"/PopularMovies",
  suggestedforyou:"/Suggestedforyou",
  popularCharacters:"/PopularCharacters",
  accountCreationSuccess: "/accountCreationSuccess"
}

export const AIToolRoutes = [
  // ROUTES.imageEnhance,
  ROUTES.faceSwap,
  ROUTES.colorize,
  ROUTES.sceneSwap,
  ROUTES.textToImage,
  ROUTES.textToVideo,
  ROUTES.voiceCloneLanding,
  ROUTES.voiceRemix,
  ROUTES.talkingAvatarLanding,
  ROUTES.actionGeneration,
  ROUTES.imageToVideo,
  ROUTES.aiDashboard,
  ROUTES.motionControl,
  ROUTES.songGeneration,
  ROUTES.videoDubbing,
  ROUTES.creativeEditor,
  ROUTES.moderation
]

export const AUTH_TOOL_ROUTES = [
  // ROUTES.imageEnhance,
  ROUTES.faceSwap,
  ROUTES.colorize,
  ROUTES.sceneSwap,
  ROUTES.voiceCloneLanding,
  ROUTES.textToImage,
  ROUTES.textToVideo,
  ROUTES.voiceRemix,
  ROUTES.actionGeneration,
  ROUTES.imageToVideo,
  ROUTES.voiceLibrary,
  ROUTES.voiceRecorder,
  ROUTES.editVoiceClone,
  ROUTES.talkingAvatarLanding,
  ROUTES.notifications,
  ROUTES.source,
  ROUTES.motionControl,
  ROUTES.songGeneration,
  ROUTES.videoDubbing,
  ROUTES.creativeEditor,
  ROUTES.moderation
]
